import { useState } from "react";
import ApkHistory from "./ApkHistory";
import ApkManagerPage from "./ApkManager";

const ApkManagerindex = () => {
  const [mode, setMode] = useState("main");
  const [selectedApp, setSelectedApp] = useState(null);

  const handleViewHistory = (app) => {
    setSelectedApp(app);
    setMode("history");
  };

  const handleBack = () => {
    setSelectedApp(null);
    setMode("main");
  };

  return (
    <>
      {mode === "main" ? (
        <ApkManagerPage onViewHistory={handleViewHistory} />
      ) : (
        <ApkHistory app={selectedApp} onBack={handleBack} />
      )}
    </>
  );
};

export default ApkManagerindex;